import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addSection, clearSectionState } from "../../redux/Slices/SectionSlice";
import { validateFieldLanguage } from "../../Utils/languageValidation";
import { fetchSettingsGrades } from "../../redux/Slices/GradesSlice";
import { toast } from "react-toastify";

const AddSection = ({ onSuccess }) => {
  const dispatch = useDispatch();

  const { data: sections, addLoading, addError, addSuccessMessage } = useSelector((state) => state.sections);
  const { settingsGrades } = useSelector((state) => state.grades);

  const [formData, setFormData] = useState({
    name_ar: "",
    name_en: "",
    grade_id: "",
    status: "1",
  });

  useEffect(() => {
    dispatch(clearSectionState());
    dispatch(fetchSettingsGrades());
  }, [dispatch]);

  useEffect(() => {
    if (settingsGrades && settingsGrades.length > 0 && !formData.grade_id) {
      setFormData(prev => ({ ...prev, grade_id: String(settingsGrades[0].id) }));
    }
  }, [settingsGrades, formData.grade_id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.grade_id) {
      toast.error("يرجى اختيار صف دراسي أولاً");
      return;
    }

    // BUG-26 fix: التحقق من لغة الحقول
    const arError = validateFieldLanguage(formData.name_ar, "ar");
    if (arError) return toast.error(arError);
    const enError = validateFieldLanguage(formData.name_en, "en");
    if (enError) return toast.error(enError);

    // التحقق من عدم تكرار الاسم العربي أو الإنجليزي لنفس الصف الدراسي
    const isDuplicateAr = Array.isArray(sections) && sections.some(
      (s) =>
        Number(s.grade_id) === Number(formData.grade_id) &&
        s.name_ar.trim().toLowerCase() === formData.name_ar.trim().toLowerCase()
    );
    if (isDuplicateAr) {
      toast.error("هذا الاسم العربي للقسم مكرر بالفعل لهذا الصف الدراسي");
      return;
    }

    const isDuplicateEn = Array.isArray(sections) && sections.some(
      (s) =>
        Number(s.grade_id) === Number(formData.grade_id) &&
        s.name_en.trim().toLowerCase() === formData.name_en.trim().toLowerCase()
    );
    if (isDuplicateEn) {
      toast.error("هذا الاسم الإنجليزي للقسم مكرر بالفعل لهذا الصف الدراسي");
      return;
    }

    const submitData = {
      ...formData,
      grade_id: parseInt(formData.grade_id),
      status: formData.status
    };
    dispatch(addSection(submitData));
  };

  useEffect(() => {
    if (addSuccessMessage) {
      toast.success(addSuccessMessage);
      setFormData({
        name_ar: "",
        name_en: "",
        grade_id: settingsGrades && settingsGrades.length > 0 ? String(settingsGrades[0].id) : "",
        status: "1",
      });
      if (onSuccess) onSuccess();
    }
    if (addError) {
      toast.error(addError);
    }
  }, [addSuccessMessage, addError, onSuccess, settingsGrades]);

  const inputStyle = {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 9,
    border: "1.5px solid #e2e8f0",
    fontSize: 14,
    outline: "none",
    boxSizing: "border-box",
    fontFamily: "inherit",
    background: "#fff",
    transition: "border-color 0.2s, box-shadow 0.2s"
  };

  const labelStyle = {
    fontSize: 12,
    fontWeight: 700,
    color: "#64748b",
    display: "block",
    marginBottom: 6,
    textAlign: "right"
  };

  const focusHandler = (e) => {
    e.target.style.borderColor = "var(--main-color)";
    e.target.style.boxShadow = "0 0 0 3px rgba(228, 109, 23, 0.1)";
  };

  const blurHandler = (e) => {
    e.target.style.borderColor = "#e2e8f0";
    e.target.style.boxShadow = "none";
  };

  return (
    <div style={{ direction: "rtl" }}>
      <style>{`
        .sec-custom-select {
          width: 100% !important;
          padding: 10px 14px !important;
          padding-left: 40px !important;
          border-radius: 9px !important;
          border: 1.5px solid #e2e8f0 !important;
          font-size: 14px !important;
          outline: none !important;
          box-sizing: border-box !important;
          background-color: #fff !important;
          appearance: none !important;
          -webkit-appearance: none !important;
          -moz-appearance: none !important;
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'><polyline points='6 9 12 15 18 9'></polyline></svg>") !important;
          background-repeat: no-repeat !important;
          background-position: left 14px center !important;
          background-size: 16px !important;
          cursor: pointer !important;
          transition: border-color 0.2s, box-shadow 0.2s !important;
        }
        .sec-custom-select:focus {
          border-color: var(--main-color) !important;
          box-shadow: 0 0 0 3px rgba(228, 109, 23, 0.1) !important;
        }
      `}</style>

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label style={labelStyle}>اسم القسم (عربي) *</label>
            <input
              type="text"
              style={inputStyle}
              name="name_ar"
              value={formData.name_ar}
              onChange={handleChange}
              onFocus={focusHandler}
              onBlur={blurHandler}
              placeholder="مثال: علمي علوم..."
              required
            />
          </div>
          <div className="col-md-6 mb-3">
            <label style={labelStyle}>اسم القسم (إنجليزي) *</label>
            <input
              type="text"
              style={inputStyle}
              name="name_en"
              value={formData.name_en}
              onChange={handleChange}
              onFocus={focusHandler}
              onBlur={blurHandler}
              placeholder="مثال: Scientific (Biology)..."
              required
            />
          </div>
          <div className="col-md-6 mb-3">
            <label style={labelStyle}>الصف الدراسي المرتبط به *</label>
            <select
              className="sec-custom-select"
              name="grade_id"
              value={formData.grade_id ? String(formData.grade_id) : ""}
              onChange={handleChange}
              required
            >
              <option value="" disabled>اختر الصف الدراسي</option>
              {settingsGrades && settingsGrades.map((g) => (
                <option key={g.id} value={String(g.id)}>{g.name_ar}</option>
              ))}
            </select>
          </div>
          <div className="col-md-6 mb-3">
            <label style={labelStyle}>حالة النشاط *</label>
            <select
              className="sec-custom-select"
              name="status"
              value={formData.status ? String(formData.status) : "1"}
              onChange={handleChange}
              required
            >
              <option value="1">نشط</option>
              <option value="0">غير نشط</option>
            </select>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, borderTop: "1px solid #f1f5f9", marginTop: 15, paddingTop: 15 }}>
          <button type="button" onClick={onSuccess} style={{ padding: "8px 20px", borderRadius: 9, border: "1px solid #cbd5e1", background: "#fff", color: "#475569", fontWeight: 700, cursor: "pointer", fontSize: 13 }}>إلغاء</button>
          <button type="submit" disabled={addLoading} style={{ padding: "8px 26px", borderRadius: 9, border: "none", background: "linear-gradient(135deg,var(--main-color),var(--main-light))", color: "#fff", fontWeight: 700, cursor: "pointer", fontSize: 13 }}>
            {addLoading ? 'جاري الحفظ...' : 'إضافة القسم'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddSection;